import { AssetsHashMap, GroupsHashMap } from 'common/types';

import { OrderBookDto } from 'components/OrderBook/types';

export const initialState: {
  stocks: AssetsHashMap;
  groups: GroupsHashMap;
  favorites: string[];
  loading: {
    stocks: boolean;
    stocksInitial: boolean;
    groups: boolean;
    groupsInitial: boolean;
    favorites: boolean;
    favoritesInitial: boolean;
    info: boolean;
    orders: boolean;
    ordersInitial: boolean;
    ordersClosed: boolean;
    ordersClosedInitial: boolean;
    positions: boolean;
    positionsInitial: boolean;
    history: boolean;
    historyInitial: boolean;
  };
  orderbook: {
    [key: string]: OrderBookDto;
  };
} = {
  stocks: {},
  groups: {},
  favorites: [],
  loading: {
    stocks: true,
    stocksInitial: true,
    groups: true,
    groupsInitial: true,
    favorites: true,
    favoritesInitial: true,
    info: false,
    orders: false,
    ordersInitial: true,
    ordersClosed: false,
    ordersClosedInitial: true,
    positions: false,
    positionsInitial: true,
    history: false,
    historyInitial: true,
  },
  orderbook: {},
};
